import {
  Breakpoints,
  CTA,
  styled,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import {Pin} from '@volkswagen-onehub/icons-core';
import React, {useContext} from 'react';
import {getLang, getTranslations} from '../../translations';
import { BasicDealerData, DealerData } from '../../types';
import {formatDistance} from '../../utils/format';
import {
  ResultsView,
  ResultsViewContext,
} from '../../utils/results-view-context';
import useDealerUrl from '../../utils/use-dealer-url';

type ViewProps = {
  isDetailPage?: boolean;
  view: ResultsView;
};

const TextContainer = styled.div<ViewProps>`
  display: flex;

  ${(props) =>
    !props.isDetailPage
      ? `
    flex-direction: column;
    column-gap: ${props.theme.size.static100};
  `
      : `align-items: center;`}
  span {
    margin: 0;
    display: block;
  }
  a svg,
  a span {
    display: inline;
  }
  @media (min-width: ${Breakpoints.b560}px) {
    /* flex-direction: ${(props) =>
      props.view === ResultsView.LIST ? `row` : `column`}; */
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  div[class^='StyledLinkWrapper'] {
    column-gap: ${(props) => props.theme.size.static100};
  }

  ${(props) =>
    props.view == ResultsView.LIST &&
    `
    @media screen and (min-width: ${Breakpoints.b960}px) {
      margin-top: ${props.theme.size.dynamic0020};
    }
  `}
`;

const KmText = styled(Text)<{isDetailPage?: boolean}>`
  ${(props) =>
    !props.isDetailPage
      ? `
      padding-left: ${props.theme.size.static350}; padding-bottom: ${props.theme.size.dynamic0020};
    `
      : `
      padding-left: ${props.theme.size.static100}
    `}
`;

interface Props {
  isDetailPage?: boolean;
  dealer: DealerData | BasicDealerData;
}

export default ({dealer, isDetailPage = false}: Props) => {
  const lang = getLang();
  const {labels} = getTranslations();
  const {value: view} = useContext(ResultsViewContext);
  const dealerUrl = useDealerUrl(dealer);

  const textAppearance =
    view === ResultsView.GRID && window.innerWidth > Breakpoints.b560
      ? TokenTextAppearance.copy100
      : TokenTextAppearance.copy100;

  return (
    dealer && (
      <TextContainer view={view} isDetailPage={isDetailPage}>
        {dealerUrl && (
          <CTA
            icon={<Pin />}
            onClick={(e) => e.stopPropagation()}
            tag="a"
            href={dealerUrl}
            emphasis="tertiary"
            ariaLabel={
              (dealer as DealerData).name ||
              (dealer as BasicDealerData).fullname
            }
            target="_blank"
          >
            <Text appearance={textAppearance} tag={TextTag.span} bold>
              {(dealer as DealerData).name ||
                (dealer as BasicDealerData).fullname}
            </Text>
          </CTA>
        )}
        {(dealer as DealerData).distance > -1 && (
          <KmText
            tag={TextTag.span}
            appearance={TokenTextAppearance.copy100}
            isDetailPage={isDetailPage}
          >
            {labels.km_away.replace(
              '%%distance%%',
              formatDistance((dealer as DealerData).distance, lang),
            )}
          </KmText>
        )}
      </TextContainer>
    )
  );
};
